<template>
    <footer class="text-momo-text-light py-12" style="background-color: var(--momo-secondary-blue);">
      <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 class="text-2xl mb-3" style="font-family: 'Monaz', cursive; color: var(--momo-text-light);">
              momo the cat
            </h3>
            <p style="font-family: 'Open Sans', sans-serif; opacity: 0.9;">
                Contact: ogmomothecat@gmail.com
            </p>
          </div>
  
          <div>
            <h4 class="text-lg font-semibold mb-4" style="font-family: 'Open Sans', sans-serif;">Explore</h4>
            <ul class="space-y-2" style="font-family: 'Open Sans', sans-serif;">
              <li><router-link to="/" class="hover:text-momo-accent-coral transition-colors duration-300">Home</router-link></li>
              
              <li>
                <router-link v-if="isDesktop" to="/editor" class="hover:text-momo-accent-coral transition-colors duration-300">
                  Meme Generator
                </router-link>
                <span v-else class="opacity-50 cursor-not-allowed">
                  Meme Generator (Desktop Only)
                </span>
              </li>
              </ul>
          </div>
  
          <div>
            <h4 class="text-lg font-semibold mb-4" style="font-family: 'Open Sans', sans-serif;">Follow Us</h4>
            <div class="flex space-x-4">
              <a :href="links.twitter" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaXTwitter />
              </a>
              <a :href="links.telegram" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaTelegramPlane />
              </a>
              <a :href="links.instagram" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaInstagram />
              </a>
              <a :href="links.tiktok" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaTiktok />
              </a>
              <a :href="links.youtube" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaYoutube />
              </a>
              <a :href="links.snapchat" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaSnapchat />
              </a>
              <a :href="links.facebook" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaFacebook />
              </a>
              <a :href="links.chart" target="_blank" rel="noopener noreferrer" class="social-icon-link">
                <FaChartLine />
              </a>
            </div>
          </div>
        </div>
  
        <div class="text-center pt-8 border-t" style="border-color: rgba(255,255,255,0.2); font-family: 'Open Sans', sans-serif; opacity: 0.8;">
          &copy; {{ new Date().getFullYear() }} momo the cat. All Rights Reserved.
        </div>
      </div>
    </footer>
  </template>
  
  <script setup lang="ts">
  // --- ADDED SCRIPT LOGIC FOR SCREEN SIZE DETECTION ---
  import { ref, onMounted, onUnmounted } from 'vue';
  import { FaTelegramPlane, FaTiktok, FaInstagram, FaChartLine, FaYoutube, FaSnapchat, FaFacebook } from "vue3-icons/fa";
  import { FaXTwitter } from "vue3-icons/fa6";
  
  const links = {
    twitter: "https://x.com/ogmomothecat",
    telegram: "https://t.me/ogmomothecatverify",
    instagram: "https://www.instagram.com/ogmomothecat",
    tiktok: "https://tiktok.com/@ogmomothecat",
    youtube: "https://www.youtube.com/@ogmomothecat",
    snapchat: "https://snapchat.com/t/EZyumCfN",
    facebook: "https://www.facebook.com/share/16xQ97cmit/?mibextid=wwXIfr",
    chart: "https://dexscreener.com/solana/9ww754k5ju7jnvj6rpapf1bgbpbpe5bzjvzmxye1fifw",
  };
  
  // Reactive variable to track if the view is desktop
  const isDesktop = ref(true);

  // Function to check screen width
  const checkScreenSize = () => {
    isDesktop.value = window.innerWidth > 768; // 768px is a common breakpoint for tablets
  };

  // Add event listener when the component mounts
  onMounted(() => {
    checkScreenSize(); // Check on initial load
    window.addEventListener('resize', checkScreenSize);
  });

  // Clean up the event listener when the component unmounts
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });
  </script>
  
  <style scoped>
  .container {
    max-width: 1280px; /* Or your preferred max-width for content within full-width sections */
  }
  
  .social-icon-link {
    cursor: pointer;
    font-size: 1.75rem; /* 28px */
    color: var(--momo-text-light);
    transition: all 0.3s ease;
  }
  
  .social-icon-link:hover {
    color: var(--momo-accent-coral);
    transform: scale(1.1);
  }
  </style>